<script setup lang="ts">
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useAuth } from '@/entities/Auth'
import { VIcons } from '@/shared/ui'
import { ObjectTypesDeleteButton } from '@/features/Inventory/ObjectTypesDelete'
import { ObjectTypesDuplicateButton } from '@/features/Inventory/ObjectTypesDuplicate'

const props = defineProps({
  elementId: {
    type: Number,
    required: true,
  },
  typeId: {
    type: Number,
    required: true,
  },
  objectId: {
    type: String,
    required: true,
  },
  section: {
    type: String,
    required: true,
  },
})
const emits = defineEmits(['changed'])

const route = useRoute()
const router = useRouter()
const auth = useAuth()

const canUpdate = computed(() => auth.hasTypePermission(props.typeId, 'update'))
const canDelete = computed(() => auth.hasTypePermission(props.typeId, 'delete'))
const canCreate = computed(() => auth.hasTypePermission(props.typeId, 'create'))

/**
 * Куда ведёт кнопка просмотра строки. Конструктор (edit-v2) — только
 * для паспортов типов; справочники правятся своей табличной карточкой.
 */
const viewLink = computed(() =>
  router.resolve({
    name: 'objects.groups.admin',
    params: {
      ...route.params,
      action: props.section === 'passports-config' ? 'edit-v2' : 'edit',
      entity_id: props.elementId,
    },
    query: {
      object_type: props.typeId,
    },
  }),
)
</script>

<template>
  <div class="object-type-card__actions">
    <VTooltip v-if="canUpdate" location="top" :open-delay="500" :text="$t('itf.view')">
      <template #activator="{ props: tipProps }">
        <VBtn :to="viewLink" icon density="compact" v-bind="tipProps">
          <VIcons type="visibility" />
        </VBtn>
      </template>
    </VTooltip>

    <ObjectTypesDeleteButton
      v-if="canDelete"
      :id="elementId"
      :object_id="objectId"
      @deleted="emits('changed')"
    />

    <ObjectTypesDuplicateButton
      v-if="canCreate"
      :id="elementId"
      :object_id="objectId"
      @duplicated="emits('changed')"
    />
  </div>
</template>
